// Module
var code = "<div class=\"vui-switch\" ng-click=\"$ctrl.onClick()\" ng-class=\"{\n        'checked': $ctrl.ngModel,\n        'disabled': $ctrl.disabled\n    }\">\n    <div class=\"vui-switch__thumb\"></div>\n    <input class=\"vui-switch__checkbox\" type=\"checkbox\" ng-model=\"$ctrl.ngModel\">\n</div>\n";
// Exports
module.exports = code;